import { useNavigate } from 'react-router-dom';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';

const sections = [
  {
    title: '一、信息收集',
    content: `寻御科技（上海）有限公司（以下简称"本公司"或"我们"）在您使用我们的产品和服务时，可能收集以下类型的信息：

• **基本信息**：包括您的姓名、联系电话、电子邮箱、所在公司名称及职位等，用于提供服务和沟通联系。
• **使用数据**：包括您访问我们平台的日志记录、操作行为、设备信息、IP地址等，用于改善产品体验和安全保障。
• **业务数据**：您在使用工信部碳排放申报、CCER/CBAM合规填报等服务时上传的企业能耗、排放数据等，仅用于为您提供相关服务。
• **沟通记录**：您与我们的客服、顾问的沟通内容，用于服务改进和问题追溯。`,
  },
  {
    title: '二、信息使用',
    content: `我们收集的信息将用于以下目的：

• 提供、维护和改进我们的产品与服务；
• 处理您的服务申请、咨询请求及技术支持；
• 向您发送与服务相关的通知、更新和技术信息；
• 遵守法律法规要求及监管机构要求；
• 分析使用模式以优化用户体验；
• 预防欺诈、滥用及安全威胁。

我们不会将您的个人信息出售给第三方，也不会在未经您同意的情况下将其用于本隐私政策未描述的其他用途。`,
  },
  {
    title: '三、信息共享',
    content: `在以下情况下，我们可能与第三方共享您的信息：

• **服务提供商**：与协助我们提供服务的可信赖合作伙伴共享必要信息，这些合作方受到严格保密义务约束；
• **法律要求**：在法律法规、政府机关或司法机构要求时予以披露；
• **企业变更**：发生合并、收购或资产转让时，您的信息可能作为业务资产转移，届时我们将提前通知您；
• **您的同意**：在获得您明确同意的情况下向第三方共享。`,
  },
  {
    title: '四、数据安全',
    content: `我们高度重视您的数据安全，采取以下措施保护您的信息：

• 采用业界标准的 SSL/TLS 加密传输协议；
• 业务数据支持区块链存证，确保不可篡改；
• 服务器部署在符合国家等级保护要求的数据中心；
• 实施严格的内部数据访问权限控制，最小化数据接触范围；
• 定期进行安全审计和漏洞扫描；
• 发生数据安全事件时，我们将在规定时间内通知受影响用户并向监管机构报告。`,
  },
  {
    title: '五、数据保留',
    content: `我们将在实现本隐私政策所述目的所必要的期限内保留您的个人信息。具体保留期限如下：

• 账户信息：在您注销账户后保留 30 天，以便处理可能的纠纷；
• 业务数据（碳排放数据等）：根据法律法规要求，合规相关数据保留不少于 5 年；
• 日志数据：通常保留 12 个月；
• 您可随时申请删除您的个人信息，但法律法规要求保留的信息除外。`,
  },
  {
    title: '六、您的权利',
    content: `根据中华人民共和国《个人信息保护法》及相关法律法规，您享有以下权利：

• **访问权**：您有权查询我们持有的关于您的个人信息；
• **更正权**：您有权要求更正不准确的个人信息；
• **删除权**：在法律允许的范围内，您可要求删除您的个人信息；
• **可携带权**：您有权以结构化、通用格式获取您的个人信息；
• **撤回同意**：您可随时撤回对信息处理的同意，但不影响撤回前已处理行为的合法性；
• **投诉权**：您有权向个人信息保护主管部门投诉。

如需行使上述权利，请通过文末联系方式与我们联系。`,
  },
  {
    title: '七、Cookie 使用',
    content: `我们的平台使用 Cookie 及类似技术改善用户体验。Cookie 是存储在您设备上的小型文本文件，用于：

• 保持您的登录状态；
• 记住您的偏好设置；
• 分析平台使用情况；
• 提供个性化内容。

您可通过浏览器设置管理或禁用 Cookie，但这可能影响部分功能的正常使用。`,
  },
  {
    title: '八、未成年人保护',
    content: `我们的服务面向企业用户（B端），不面向 18 周岁以下未成年人。如果我们发现误收集了未成年人的个人信息，将立即予以删除。如果您认为我们可能持有未成年人的信息，请立即联系我们。`,
  },
  {
    title: '九、隐私政策更新',
    content: `我们可能不时更新本隐私政策。重大变更将通过平台公告、电子邮件等方式提前通知您。更新后继续使用我们的服务，即视为您接受修订后的隐私政策。建议您定期查阅本页面了解最新内容。`,
  },
  {
    title: '十、联系我们',
    content: `如您对本隐私政策有任何疑问、意见或请求，请通过以下方式联系我们：

• **公司名称**：寻御科技（上海）有限公司
• **地址**：上海市虹口区水电路1388号
• **电子邮箱**：info@xunyutech.cn
• **联系电话**：18916035855

我们将在收到您的请求后 15 个工作日内予以回复。`,
  },
];

export default function PrivacyPage() {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-firmai-dark">
      <Navbar />
      <main>
        {/* Hero */}
        <section className="relative pt-32 pb-12 bg-firmai-darker overflow-hidden">
          <div className="absolute top-1/3 right-1/4 w-80 h-80 bg-firmai-green/6 rounded-full blur-3xl pointer-events-none" />
          <div className="w-full px-4 md:px-8 lg:px-12 relative z-10">
            <div className="max-w-3xl mx-auto">
              <nav className="flex items-center gap-2 text-xs text-firmai-muted mb-6">
                <a href="/" onClick={(e) => { e.preventDefault(); navigate('/'); }} className="hover:text-firmai-green transition-colors cursor-pointer">首页</a>
                <span className="w-3 h-3 flex items-center justify-center"><i className="ri-arrow-right-s-line" /></span>
                <span className="text-firmai-text">隐私政策</span>
              </nav>
              <span className="inline-flex items-center gap-2 px-3 py-1 rounded-full bg-firmai-green/10 border border-firmai-green/25 text-firmai-green text-xs font-semibold mb-4">
                <span className="w-3 h-3 flex items-center justify-center"><i className="ri-shield-user-line" /></span>
                法律文件
              </span>
              <h1 className="font-display font-bold text-3xl md:text-4xl text-white mb-4">隐私政策</h1>
              <p className="text-firmai-text text-sm leading-relaxed">
                最后更新日期：2026年1月1日 &nbsp;·&nbsp; 生效日期：2026年1月1日
              </p>
              <p className="text-firmai-muted text-sm mt-3 leading-relaxed max-w-2xl">
                寻御科技（上海）有限公司尊重并保护所有使用本公司服务用户的个人隐私权。为了给您提供更准确、更有个性化的服务，本公司会按照本隐私政策的规定使用和披露您的个人信息。
              </p>
            </div>
          </div>
        </section>

        {/* Content */}
        <section className="py-14 bg-firmai-dark">
          <div className="w-full px-4 md:px-8 lg:px-12">
            <div className="max-w-3xl mx-auto">
              <div className="space-y-10">
                {sections.map((sec) => (
                  <div key={sec.title} className="bg-firmai-card border border-firmai-border rounded-xl p-6 md:p-8">
                    <h2 className="text-white font-bold text-base md:text-lg mb-4 flex items-center gap-2">
                      <span className="w-1 h-5 bg-firmai-green rounded-full inline-block shrink-0" />
                      {sec.title}
                    </h2>
                    <div className="text-firmai-text text-sm leading-relaxed whitespace-pre-line">
                      {sec.content.split('\n').map((line, i) => {
                        if (line.startsWith('• **') && line.includes('**：')) {
                          const parts = line.replace('• **', '').split('**：');
                          return (
                            <p key={i} className="mb-2 pl-3">
                              <span className="text-firmai-green font-semibold">{parts[0]}</span>
                              <span className="text-firmai-muted">：</span>
                              {parts[1]}
                            </p>
                          );
                        }
                        if (line.startsWith('• ')) {
                          return <p key={i} className="mb-2 pl-3 flex items-start gap-2"><span className="text-firmai-green mt-1.5 shrink-0">·</span>{line.replace('• ', '')}</p>;
                        }
                        if (line === '') return <div key={i} className="h-2" />;
                        return <p key={i} className="mb-2">{line}</p>;
                      })}
                    </div>
                  </div>
                ))}
              </div>

              {/* Bottom nav */}
              <div className="mt-10 flex flex-col sm:flex-row items-center justify-between gap-4 pt-8 border-t border-firmai-border">
                <div className="flex items-center gap-4 text-sm">
                  <a href="/terms" onClick={(e) => { e.preventDefault(); navigate('/terms'); }} className="text-firmai-muted hover:text-firmai-green transition-colors cursor-pointer">服务条款</a>
                  <span className="text-firmai-border">|</span>
                  <a href="/copyright" onClick={(e) => { e.preventDefault(); navigate('/copyright'); }} className="text-firmai-muted hover:text-firmai-green transition-colors cursor-pointer">版权声明</a>
                </div>
                <a
                  href="/contact"
                  onClick={(e) => { e.preventDefault(); navigate('/contact'); }}
                  className="inline-flex items-center gap-2 px-5 py-2.5 bg-firmai-green text-firmai-dark font-semibold rounded-md hover:bg-firmai-green/90 transition-all duration-200 whitespace-nowrap text-sm cursor-pointer"
                >
                  联系我们
                  <span className="w-4 h-4 flex items-center justify-center"><i className="ri-arrow-right-line" /></span>
                </a>
              </div>
            </div>
          </div>
        </section>
      </main>
      <Footer />
    </div>
  );
}